const item = Object.freeze({
  Donation: 1,
  Auxiliary: 2,
});
export default item;
